import { render, staticRenderFns } from "./gdConfigInfos.vue?vue&type=template&id=402728b0&scoped=true"
import script from "./gdConfigInfos.vue?vue&type=script&lang=js"
export * from "./gdConfigInfos.vue?vue&type=script&lang=js"
import style0 from "./gdConfigInfos.vue?vue&type=style&index=0&id=402728b0&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "402728b0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('402728b0')) {
      api.createRecord('402728b0', component.options)
    } else {
      api.reload('402728b0', component.options)
    }
    module.hot.accept("./gdConfigInfos.vue?vue&type=template&id=402728b0&scoped=true", function () {
      api.rerender('402728b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/tpm/views/banquet_management/banquet_reward_configuration/form/components/gdConfigInfos.vue"
export default component.exports